import { render, staticRenderFns } from "./FourRow.vue?vue&type=template&id=12be83a4&scoped=true&"
import script from "./FourRow.vue?vue&type=script&lang=js&"
export * from "./FourRow.vue?vue&type=script&lang=js&"
import style0 from "./FourRow.vue?vue&type=style&index=0&id=12be83a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be83a4",
  null
  
)

export default component.exports